import { Pencil } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router';
import { Button } from '@/components/ui/button';
import type { DomainDetail } from '../../../api';

export interface DomainTabProps {
  detail: DomainDetail;
  /** Reloads the domain (after an action taken from the tab). */
  reload?: () => void;
}

/** A button that opens one of the domain's action dialogs (`?action=`) from inside a tab. */
export function EditAction({ detail, action, label }: { detail: DomainDetail; action: string; label?: string }) {
  const { t } = useTranslation('ux');
  const [params] = useSearchParams();
  const p = new URLSearchParams(params);
  p.set('action', action);
  const active = detail.domain.lifecycle_state === 'ACTIVE' || detail.domain.lifecycle_state === 'GRACE_PERIOD';
  if (!active) return null;
  return (
    <Button asChild variant="outline" size="sm">
      <Link to={`?${p.toString()}`} replace preventScrollReset>
        <Pencil /> {label ?? t('domain.edit')}
      </Link>
    </Button>
  );
}

/** A part of a tab that a former URL points at (`#id`). */
export function Part({ id, children }: { id: string; children: ReactNode }) {
  return (
    <div id={id} className="scroll-mt-20">
      {children}
    </div>
  );
}
